import { Button } from '@trackman/web-shared-components';
import { ReactComponent as PlusIcon } from 'images/plus.svg';
import LineupManager from 'models/setLineup/LineupManager';
import React from 'react';
import { PositionBar } from '../../PositionBar/PositionBar';
import { LineupControlsWrapper } from './LineupControlsStyles';

interface IProps {
  lineupManager: LineupManager;
}

const LineupControls: React.FC<IProps> = (props) => {
  const { lineupManager } = props;

  const addDesignatedHitter = async (): Promise<void> => {
    lineupManager?.addDesignatedHitter();
  };

  return (
    <LineupControlsWrapper>
      <PositionBar filledPositions={lineupManager.getFilledPositions()} allPositions={lineupManager.getRequiredPositions()} />
      <Button
        label='Add DH'
        onClick={addDesignatedHitter}
        disabled={!lineupManager?.isAddDesignatedHitterEnabled}
        width='99px'
        intent='tertiary'
        data-testid='add-dh-button'
        startIcon={<PlusIcon />}
        style={{ backgroundColor: '#F5F5F5', color: '#414141' }}
      />
    </LineupControlsWrapper>
  );
};

export default LineupControls;
